export default "__VITE_ASSET__w$Dd9gu1__"